module.exports = __webpack_public_path__ + "img/06.cfe9d332.png";